<template>
  <div class="w-full">
    <!-- UPLOAD AREA, really without drag&drog -->
    <div
      v-if="canUploadPhoto"
      v-uploader="uploaderOptions"
      class="bg-ambi-gray-dark grid place-items-center mt-8 cursor-pointer px-8 py-10 rounded-xl group border-transparent border-solid border-1 hover:border-ambi-red"
    >
      <div class="text-center space-y-3">
        <div>
          <aw-icon
            icon="upload-foto-placeholder"
            class="w-20 h-20 text-divider-dark group-hover:text-ambi-red"
          />
        </div>
        <div class="group-hover:text-ambi-red text-h4">Nahrajte fotografii</div>
        <div class="text-gray-400 text-p3">
          Maximální velikost obrázku je 2 MB, povolené přípony jsou pouze
          JPG/JPEG/PNG.
        </div>
      </div>
    </div>

    <!-- Progress bar with current progress of uploading -->
    <div v-if="percentCompleted > 0" class="mt-2">
      <div>
        <div
          class="px-2 text-sm rounded-md bg-green-700 text-white"
          :style="{
            width: percentCompleted + '%'
          }"
        >
          {{ percentCompleted }}%
        </div>
      </div>
    </div>

    <!-- Uploaded photo -->
    <div v-if="photoUploaded">
      <div
        class="rounded-xl mt-8 relative grid place-items-center"
        style="grid-template-rows: 400px"
      >
        <img
          class="block w-full h-full rounded-xl object-contain border-px border-solid border-divider-dark"
          :src="renderPhoto"
          alt=""
        />
      </div>
      <div class="text-center mt-4">
        <span @click="deleteFile(0)" class="Btn -Gray -Small">
          Změnit fotografii / smazat
          <aw-icon icon="close" class="w-5 h-5" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['filesNamesId', 'filesIdsId'],
  data() {
    return {
      maxAttachments: 1,
      percentCompleted: 0,
      file: null
    }
  },
  mounted() {},
  computed: {
    renderPhoto() {
      return `/storage/images/fb-image/${this.file.id}.${this.file.ext}`
    },
    photoUploaded() {
      return this.attachmentsListIds.length
    },
    canUploadPhoto() {
      return this.photoUploaded === 0
    },
    attachmentsListIds: {
      get() {
        return this.$formValues[this.filesIdsId]
          .split(';')
          .filter((el) => el != '')
      },
      set(newArr) {
        this.$formValues[this.filesIdsId + ':change'] = newArr.join(';')
      }
    },
    attachmentsListNames: {
      get() {
        return this.$formValues[this.filesNamesId]
          .split(';')
          .filter((el) => el != '')
      },
      set(newArr) {
        this.$formValues[this.filesNamesId + ':change'] = newArr.join(';')
      }
    },
    uploaderOptions() {
      return {
        url: `/service/image/upload?folderId=100`,
        exts: null,
        maxUploadFiles: 1,
        onFileUploadDone: this.fileUploadDone,
        onProgress: this.progress,
        onError: this.error,
        name: 'qqfile'
      }
    }
  },
  methods: {
    deleteFile(index) {
      const attachmentsListNames = this.attachmentsListNames
      attachmentsListNames.splice(index, 1)

      const attachmentsListIds = this.attachmentsListIds
      attachmentsListIds.splice(index, 1)

      // vue reactivity caveat
      this.attachmentsListNames = attachmentsListNames
      this.attachmentsListIds = attachmentsListIds
      this.file = null
    },
    fileUploadDone(data) {
      this.file = data
      this.uploadError = false

      const attachmentsListIds = this.attachmentsListIds
      attachmentsListIds.push(data.id)

      const attachmentsListNames = this.attachmentsListNames
      attachmentsListNames.push(data.file_name)

      // vue reactivity caveat
      this.attachmentsListNames = attachmentsListNames
      this.attachmentsListIds = attachmentsListIds
    },
    error(error) {
      this.uploadError = error
    },
    progress(progress, percentCompleted) {
      this.percentCompleted = percentCompleted
      this.uploadError = false
      if (percentCompleted === 100) {
        setTimeout(() => {
          this.percentCompleted = 0
        }, 1000)
      }
    }
  }
}
</script>
